import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-add-region-modal',
  templateUrl: './add-region-modal.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./add-region-modal.component.scss']
})
export class AddRegionModalComponent {
  public regionForm: FormGroup
  public isLoading: boolean = false
  public isSuccess: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AddRegionModalComponent>,
    private fb: FormBuilder,
    private wellHeaderInfoService : WellHeaderInfoService,
    @Inject(MAT_DIALOG_DATA) public companyId: any,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(){
    this.regionForm = this.initializeForm()
  }

  initializeForm(){
    return this.fb.group({
      companyId: this.companyId,
      regionLongName: ['', [Validators.required, noWhitespaceValidator()]],
      regionShortName: ['', [Validators.required, noWhitespaceValidator()]],
      remark: '',
    })
  }

  createRegion(){
    this.wellHeaderInfoService.createPsc( this.regionForm.value).subscribe((res)=>{
      if(res.isSuccess){
        this.isSuccess = true
        this.closeDialog()
      }
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get regionLongName() {
    return this.regionForm.get('regionLongName');
  }

  get regionShortName() {
    return this.regionForm.get('regionShortName');
  }
}
